export enum AnalyticsInterval {
    OneHour = '1h',
    OneDay = '1d',
    OneWeek = '1w',
    OneMonth = '1m',
}
